import { observer } from 'mobx-react';
import React, { useCallback, useEffect } from 'react';
import WebsiteInfoWysiwyg from '../../containers/WebsiteInfoWysiwyg/WebsiteInfoWysiwyg';
import franchiseStore from './store/franchiseStore';

const FranchiseScreen: React.FC = observer((): JSX.Element => {
  useEffect(() => {
    franchiseStore.init();
  }, []);

  const onChange = useCallback((template: string) => {
    franchiseStore.changeWysiwygDataHandler({ template });
  }, []);

  return (
    <WebsiteInfoWysiwyg
      value={franchiseStore.wysiwygData?.template}
      validation={franchiseStore.validation}
      isLoading={franchiseStore.isLoading}
      isFirstLoading={franchiseStore.isLoading && !franchiseStore.wysiwygData}
      isEdit={franchiseStore.isEdit}
      onChange={onChange}
      onSubmit={franchiseStore.updateWysiwygData}
    />
  );
});

export default FranchiseScreen;
